import { FC } from 'react';
import { ReferralAgentLinkEnum } from '~/src/models/enums/referral-agent-link.enum';
import { NotificationStateEnum } from '~/src/models/enums/notification-state.enum';
import { SvgSuccessNotification } from '~/src/components/svg-components/success-notification';
import { SvgError } from '~/src/components/svg-components/error';
import {
    notificationErrorText,
    notificationSuccessText,
} from '~/src/components/common-components/notification/notification.constants';
import { SvgSuccessNotificationWrapper } from './notification.styles';
import * as Styled from './notification.styles';

interface NotificationProps {
    state: ReferralAgentLinkEnum | NotificationStateEnum;
    top?: number;
    widthSuccess?: number;
    widthError?: number;
    successText?: string;
}

export const Notification: FC<NotificationProps> = ({ state, top, widthSuccess, widthError, successText }) => {
    const hasError = state === ReferralAgentLinkEnum.error;

    return (
        <Styled.Notification hasError={hasError} top={top} widthSuccess={widthSuccess} widthError={widthError}>
            <SvgSuccessNotificationWrapper>
                {hasError ? <SvgError /> : <SvgSuccessNotification />}
            </SvgSuccessNotificationWrapper>
            <Styled.TextNotification>
                {hasError ? notificationErrorText : successText || notificationSuccessText}
            </Styled.TextNotification>
        </Styled.Notification>
    );
};
